<template>
  <div>
    <v-container row wrap style="margin-right: 0px;">
      <v-layout row wrap justify-center>
        <v-flex hidden-sm-and-down>
          <v-spacer></v-spacer>
        </v-flex>
        <v-btn
          v-if="checkFunzione(elencoFunzioni.INSERIMENTO_EVENTO) || checkFunzione(elencoFunzioni.INSERIMENTO_EVENTO_ASSOCIAZIONE)"
          @click.prevent="newDialog(0)"
          class="btnDefault"
          small
          color="green darken-2"
          dark
          ><v-icon small left>add</v-icon>evento di gara
        </v-btn>

        <v-btn
          v-if="
            checkFunzione(elencoFunzioni.INSERIMENTO_EVENTO) ||
            (checkFunzione(elencoFunzioni.INSERIMENTO_EVENTO_ASSOCIAZIONE) && associazione.Denominazione === 'C.S.A.In. Comitato Provinciale Cremona')
          "
          @click.prevent="newDialog(1)"
          class="btnDefault"
          small
          color="green darken-2"
          dark
        >
          <v-icon small left>add</v-icon>
          evento formativo
        </v-btn>

        <v-btn
          v-if="checkFunzione(elencoFunzioni.INSERIMENTO_EVENTO) || checkFunzione(elencoFunzioni.INSERIMENTO_EVENTO_ASSOCIAZIONE)"
          @click.prevent="newDialog(2)"
          class="btnDefault"
          small
          color="green darken-2"
          dark
        >
          <v-icon small left>add</v-icon>
          evento didattico
        </v-btn>

        <v-btn v-if="filtroEventi.AnnoSportivo" @click="exportCalendarioCorrente()" class="btnDefault" small color="accent white--text">
          <v-icon small left>import_export</v-icon>
          {{ !isMobile ? 'Esporta Calendario ' + filtroEventi.AnnoSportivo.Descrizione : 'export calendario' }}
        </v-btn>
        <v-btn v-else @click="exportCalendarioCorrente()" class="btnDefault" small disabled color="accent white--text">
          <v-icon small left>import_export</v-icon>
          {{ !isMobile ? 'selezionare l"annosportivo ' : 'selezionare l"annosportivo' }}
        </v-btn>

        <v-btn @click="refreshEventi()" class="btnDefault" small color="primary white--text"> <v-icon small left color="white">cached</v-icon>Aggiorna </v-btn>
      </v-layout>
    </v-container>

    <v-container fluid pt-0>
      <v-layout row wrap>
        <v-flex xs12 md2>
          <v-layout row wrap>
            <v-flex xs12>
              <v-select
                v-model="filtroEventi.AnnoSportivo"
                :items="anniSportivi"
                @change="filtraAnnoSez"
                box
                item-text="Descrizione"
                label="Anno Sportivo"
                return-object
                hide-details
              ></v-select>
            </v-flex>
            <v-flex xs12 mt-2>
              <v-autocomplete
                v-model="filtroEventi.Sezione"
                :items="sezioni"
                @change="filtraSez"
                item-value="id"
                item-text="Descrizione"
                box
                label="Regione"
                clearable
                hide-details
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 mt-2>
              <v-autocomplete
                v-model="filtroEventi.TipoEvento"
                :items="tipiEvento"
                @change="filtraTipoEvt"
                item-text="Descrizione"
                return-object
                box
                label="Tipo Evento"
                clearable
                hide-details
              ></v-autocomplete>
            </v-flex>
            <v-flex v-if="filtroEventi.isGara === true" xs12 mt-2>
              <v-autocomplete
                v-model="filtroEventi.isIndoorOutdoor"
                :items="inoutdoor"
                @change="filtraTipoTag"
                clerable
                return-object
                box
                label="Indoor/Outdoor"
                clearable
                hide-details
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 ma-0 mt-3 pa-0>
              <v-layout row wrap>
                <v-flex xs12 md4><label class="primary--text pa-1 pr-3">EVENTI</label></v-flex>
                <v-flex xs12 md4 class="textR pa-0 pr-3 pt-0 font-weight-bold">
                  <label :class="filtroEventi.isGara === false ? 'primary--text' : 'colorDisabled'">
                    Formativi Didattici
                  </label>
                </v-flex>
                <v-flex xs12 md4><v-switch v-model="filtroEventi.isGara" @change="filtraGaraForDida" class="switchEventi ma-0 mt-0 pa-0" label="Gare"></v-switch></v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 ma-0 mt-1 pa-0>
              <v-layout row wrap>
                <v-flex xs12 md4> <label class="text-uppercase primary--text pa-1 pr-3">Attivi</label></v-flex>
                <v-flex xs12 md4 class="textR pa-0 pr-3 pt-0 font-weight-bold">
                  <label :class="filtroEventi.isAperti === false ? 'primary--text' : 'colorDisabled'">
                    Tutti
                  </label>
                </v-flex>
                <v-flex xs12 md4><v-switch v-model="filtroEventi.isAperti" @change="filtraAperti" label="Correnti" class="switchEventi ma-0 mt-0 pa-0"></v-switch></v-flex>
              </v-layout>
            </v-flex>
            <v-flex v-if="isFiltroIscritto()" xs12 ma-0 mt-1 pa-0>
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <label class="text-uppercase primary--text pa-1 pr-3">iscrizione</label>
                </v-flex>
                <v-flex xs12 md4 class="textR pa-0 pr-3 pt-0 font-weight-bold">
                  <label :class="filtroEventi.isNotIscritto === false ? 'primary--text' : 'colorDisabled'">
                    Già iscritto
                  </label>
                </v-flex>
                <v-flex xs12 md4><v-switch v-model="filtroEventi.isNotIscritto" @change="filtraIscritti" label="Tutti" class="switchEventi ma-0 mt-0 pa-0"></v-switch> </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 ma-0 mt-1 pa-0>
              <v-layout row wrap>
                <v-flex xs12 md4><label class="text-uppercase primary--text pa-1 pr-3">Calendario</label></v-flex>
                <v-flex xs12 md4 class="textR pa-0 pr-3 pt-0 font-weight-bold">
                  <label :class="filtroEventi.isAnnuale === false ? 'primary--text' : 'colorDisabled'">
                    Mensile
                  </label></v-flex
                >
                <v-flex xs12 md4
                  ><v-switch v-model="filtroEventi.isAnnuale" @change="filtraAnnuale" :label="filtroEventi.AnnoSportivo.Descrizione" class="switchEventi ma-0 mt-0 pa-0"></v-switch
                ></v-flex>
              </v-layout>
            </v-flex>

            <v-flex v-if="!filtroEventi.isAnnuale" xs12>
              <functional-calendar
                ref="Calendar"
                v-model="calendar"
                :marked-dates="markedDates"
                :sunday-start="false"
                :day-names="['Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa', 'Do']"
                :month-names="['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre']"
                :apply-stylesheet="false"
                @changedMonth="changedMonth"
              ></functional-calendar>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md10 class="padlist">
          <v-layout row wrap class="mb-3" justify-center>
            <v-icon left class="hidden-sm-and-down mr-3">search</v-icon>
            <v-flex md4 class="px-1">
              <v-text-field v-model="filtraEventi" box label="Cerca" clearable hide-details></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout column style="padding-top: 56px;">
            <v-data-table
              :headers="headers"
              :items="eventiMese"
              :search="filtraEventi"
              :rows-per-page-items="[10, 25, 50, { text: 'Tutti', value: -1 }]"
              :pagination.sync="pagination"
              :class="{ mobile: isMobile }"
              :hide-headers="isMobile"
              disable-initial-sort
            >
              <template slot="items" slot-scope="props">
                <tr v-if="!isMobile">
                  <td
                    v-if="props.item.TipoEventoDescrizione === 'Formazione' || props.item.TipoEventoDescrizione === 'Didattico'"
                    :class="{ 'red lighten-5': !props.item.isAttivo }"
                    bold
                    class="text-xs-right"
                  >
                    <v-avatar v-if="props.item.StatoEvento === 'Chiuso'" size="24" small>
                      <v-icon>
                        lock
                      </v-icon>
                    </v-avatar>
                    <v-avatar v-if="props.item.TipoEventoDescrizione === 'Formazione'" size="24" color="purple" small>
                      <span class="white--text xm">F</span>
                    </v-avatar>
                    <v-avatar v-else size="24" color="orange" small>
                      <span class="white--text xm">D</span>
                    </v-avatar>
                  </td>
                  <td v-else :class="{ 'red lighten-5': !props.item.isAttivo }" bold class="text-xs-right">
                    <v-avatar v-if="props.item.StatoEvento === 'Chiuso'" size="24" small>
                      <v-icon>
                        lock
                      </v-icon>
                    </v-avatar>
                    <v-avatar v-if="props.item.isOpen" size="24" color="blue" small>
                      <span class="white--text xm">O</span>
                    </v-avatar>
                    <v-avatar v-else size="24" color="red" small>
                      <span class="white--text xm">U</span>
                    </v-avatar>
                  </td>
                  <td :class="{ 'red lighten-5': !props.item.isAttivo }" @dblclick="editItem(props.item)" bold class="clickable">{{ Util.formattaData(props.item.DataEvento) }}</td>
                  <td :class="{ 'red lighten-5': !props.item.isAttivo }" @dblclick="editItem(props.item)" bold class="clickable">
                    {{ Util.formattaData(props.item.DataApertura) }}
                  </td>
                  <td :class="{ 'red lighten-5': !props.item.isAttivo }" @dblclick="editItem(props.item)" bold class="clickable">
                    {{ Util.formattaData(props.item.DataChiusura) }}
                  </td>
                  <td :class="{ 'red lighten-5': !props.item.isAttivo }" @dblclick="editItem(props.item)" class="clickable">{{ props.item.SezioneDescrizione }}</td>
                  <td :class="{ 'red lighten-5': !props.item.isAttivo }" @dblclick="editItem(props.item)" class="clickable">{{ props.item.TipoEventoDescrizione }}</td>
                  <td :class="{ 'red lighten-5': !props.item.isAttivo }" @dblclick="editItem(props.item)" class="clickable">{{ props.item.AssociazioneDenominazione }}</td>
                  <td :class="{ 'red lighten-5': !props.item.isAttivo }" @dblclick="editItem(props.item)" class="clickable">{{ props.item.CittaIndirizzo }}</td>

                  <td :class="{ 'red lighten-5': !props.item.isAttivo }" @dblclick="editItem(props.item)" class="clickable font-weight-bold">{{ props.item.TitoloEvento }}</td>

                  <td :class="{ 'red lighten-5': !props.item.isAttivo }">
                    <v-tooltip top>
                      <v-btn slot="activator" @click="manageIscritti(props.item.id, filtroEventi.AnnoSportivo.id)" small outline icon class="mr-0" color="accent">
                        <v-badge left>
                          <span slot="badge" v-if="viewBadge(props.item.DataEvento)">{{ props.item.TotalePartecipanti}}</span>
                          <v-icon small color="accent">people</v-icon>
                        </v-badge>
                      </v-btn>
                      <span v-if="userData.Role === 'ASSOCIATO'">Visualizza Iscritti</span>
                      <span v-else>Gestisci Iscritti</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn slot="activator" :disabled="!props.item.Invito" @click="downloadInvito(props.item.id)" small outline icon class="mr-0" color="blue">
                        <v-icon small color="blue">fa-file</v-icon>
                      </v-btn>
                      <span>Scarica Invito</span>
                    </v-tooltip>

                    <v-tooltip v-if="isAssociato && !disableClassifica(props.item) && props.item.TipologiaEvento === 'Gara'" top>
                      <v-btn
                        slot="activator"
                        v-if="props.item.TipologiaEvento === 'Gara'"
                        :disabled="disableClassifica(props.item)"
                        @click="manageClassifica(props.item.id)"
                        small
                        outline
                        icon
                        class="mr-0"
                        color="blue"
                      >
                        <v-icon :color="colorClassifica(props.item)" small>fa-trophy</v-icon>
                      </v-btn>
                      <span v-if="props.item.TipologiaEvento === 'Gara'">Visualizza la classifica</span>
                    </v-tooltip>

                    <v-tooltip v-if="(isAssociato && disableClassifica(props.item) || props.item.TipologiaEvento != 'Gara')" top>
                      <v-btn slot="activator" :disabled="!props.item.Piazzola" @click="downloadPiazzola(props.item.id)" small outline icon class="mr-0" color="brown">
                        <v-icon color="brown" small>map</v-icon>
                      </v-btn>
                      <span>Scarica piazzola</span>
                    </v-tooltip>

                    <v-tooltip v-if="!isAssociato && props.item.TipologiaEvento === 'Gara'" top>
                      <v-btn slot="activator" :disabled="disableClassifica(props.item)" @click="manageClassifica(props.item.id)" small outline icon class="mr-0" color="blue">
                        <v-icon :color="colorClassifica(props.item)" small>fa-trophy</v-icon>
                      </v-btn>
                      <span>Visualizza la classifica</span>
                    </v-tooltip>
                    <!--
                    <v-btn
                      slot="activator"
                      v-if="props.item.TipologiaEvento != 'Gara'"
                      :disabled="disableClassifica(props.item)"
                      @click="manageClassifica(props.item.id)"
                      small
                      outline
                      icon
                      class="mr-0"
                      color="blue"
                    >
                      <v-icon :color="colorClassifica(props.item)" small></v-icon>
                    </v-btn>
                    -->
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        v-if="canModifyEvento(props.item.id, props.item.AssociazioneId)"
                        @click="editItem(props.item)"
                        small
                        outline
                        icon
                        class="mr-0"
                        color="primary"
                      >
                        <v-icon small color="primary">edit</v-icon>
                      </v-btn>
                      <span>Modifica Evento</span>
                    </v-tooltip>
                    <v-tooltip v-if="!canModifyEvento(props.item.id, props.item.AssociazioneId) && checkFunzione(elencoFunzioni.VISUALIZZAZIONE_EVENTO)" top>
                      <v-btn slot="activator" @click="viewItem(props.item)" small outline icon class="mr-1" color="purple">
                        <v-icon small color="purple">visibility</v-icon>
                      </v-btn>
                      <span>Visualizza Scheda</span>
                    </v-tooltip>
                  </td>
                </tr>

                <tr v-else-if="caso4" style="min-height: 80px !important;">
                  <td>
                    <v-container pa-0 grid-list-md text-xs-center>
                      <v-layout row wrap>
                        <v-flex d-flex xs12 sm12 md12 lg12 pb-0>
                          <v-flex v-if="props.item.TipoEventoDescrizione === 'Formazione' || props.item.TipoEventoDescrizione === 'Didattico'" text-xs-left>
                            <v-avatar v-if="props.item.TipoEventoDescrizione === 'Formazione'" size="24" color="purple" small>
                              <span class="white--text xm">F</span>
                            </v-avatar>
                            <v-avatar v-else size="24" color="orange" small>
                              <span class="white--text xm">D</span>
                            </v-avatar>
                          </v-flex>
                          <v-flex v-else text-xs-left>
                            <v-avatar v-if="props.item.isOpen" size="24" color="blue" small>
                              <span class="white--text xm">O</span>
                            </v-avatar>
                            <v-avatar v-else size="24" color="red" small>
                              <span class="white--text xm">U</span>
                            </v-avatar>
                          </v-flex>
                          <v-flex d-flex xs10 sm6 md4>
                            <span style="font-size: 14px; font-weight: 400;">{{ props.item.AssociazioneDenominazione }}</span>
                          </v-flex>
                        </v-flex>

                        <v-flex d-flex xs12 sm12 md12 lg12 pa-0>
                          <v-flex style="text-align: left;" xs6 sm6 md4 lg5>
                            <v-flex d-flex xs12 sm6 md4 bold body-2 pa-0>{{ Util.formattaData(props.item.DataEvento) }} - {{ props.item.SezioneDescrizione }}</v-flex>
                            <v-flex d-flex xs12 sm6 md4 bold body-2 pa-0>{{ props.item.TipoEventoDescrizione }}</v-flex>
                          </v-flex>
                          <v-flex xs6 sm6 md8 lg7 style="text-align: right;">
                            <v-tooltip top>
                              <v-btn
                                slot="activator"
                                v-if="props.item.Invito"
                                :disabled="!props.item.Invito"
                                @click="downloadInvito(props.item.id)"
                                small
                                outline
                                icon
                                class="mr-0"
                                color="blue"
                              >
                                <v-icon small color="blue">fa-file</v-icon>
                              </v-btn>
                              <span>Scarica Invito</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <v-btn
                                slot="activator"
                                v-if="isAssociato && !disableClassifica(props.item) && props.item.TipologiaEvento === 'Gara'"
                                :disabled="disableClassifica(props.item)"
                                @click="manageClassifica(props.item.id)"
                                small
                                outline
                                icon
                                class="mr-0"
                                color="blue"
                              >
                                <v-icon :color="colorClassifica(props.item)" small>fa-trophy</v-icon>
                              </v-btn>
                              <v-btn
                                slot="activator"
                                v-if="!isAssociato && props.item.TipologiaEvento === 'Gara'"
                                :disabled="disableClassifica(props.item)"
                                @click="manageClassifica(props.item.id)"
                                small
                                outline
                                icon
                                class="mr-0"
                                color="blue"
                              >
                                <v-icon :color="colorClassifica(props.item)" small>fa-trophy</v-icon>
                              </v-btn>
                              <v-btn
                                slot="activator"
                                :disabled="!props.item.Piazzola"
                                v-if="(isAssociato && disableClassifica(props.item) || props.item.TipologiaEvento != 'Gara')"
                                @click="downloadPiazzola(props.item.id)"
                                small
                                outline
                                icon
                                class="mr-0"
                                color="brown"
                              >
                                <v-icon color="brown" small>map</v-icon>
                              </v-btn>
                              <span>Scarica la piazzola</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <v-btn
                                slot="activator"
                                v-if="canModifyEvento(props.item.id, props.item.AssociazioneId)"
                                @click="editItem(props.item)"
                                small
                                outline
                                icon
                                class="mr-0"
                                color="primary"
                              >
                                <v-icon small color="primary">edit</v-icon>
                              </v-btn>
                              <span>Modifica Evento</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <v-btn
                                slot="activator"
                                v-if="props.item.TotalePartecipanti > 0"
                                @click="manageIscritti(props.item.id, filtroEventi.AnnoSportivo.id)"
                                small
                                outline
                                icon
                                class="mr-0"
                                color="accent"
                              >
                                <v-icon small color="accent">people</v-icon>
                              </v-btn>
                              <span v-if="userData.Role === 'ASSOCIATO'">Visualizza Iscritti</span>
                              <span v-else>Gestisci Iscritti</span>
                            </v-tooltip>
                            <v-tooltip v-if="!canModifyEvento(props.item.id, props.item.AssociazioneId) && checkFunzione(elencoFunzioni.VISUALIZZAZIONE_EVENTO)" top>
                              <v-btn slot="activator" @click="viewItem(props.item)" small outline icon class="mr-1" color="purple">
                                <v-icon small color="purple">visibility</v-icon>
                              </v-btn>
                              <span>Visualizza Scheda</span>
                            </v-tooltip>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </td>
                </tr>
              </template>
              <template slot="no-results">
                <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun evento</v-alert>
              </template>
              <template slot="no-data">
                <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun evento</v-alert>
              </template>
            </v-data-table>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>

    <evento-form
      :evt.sync="eventoObj"
      :dt-evt.sync="dataIniziale"
      :image.sync="imageObj"
      :obj-formazione.sync="objFormazione[0]"
      :obj-didattico.sync="objDidattico[0]"
      :prop-form-mode.sync="formMode"
      @reset-elm="resetElm()"
    ></evento-form>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { FunctionalCalendar } from 'vue-functional-calendar';
  import EventoForm from './EventoForm';
  import { bus } from '@/main';
  import EventoEntity from '../generale/EventoEntity';
  import ImageEntity from '@/pages/anagrafica/generale/ImageEntity';
  import AssociazioneEntity from '../../anagrafica/associazioni/AssociazioneEntity';
  import FiltroEvento from '../generale/FiltroEvento';
  import Security from '@/security';
  import Util from '@/util';
  import * as moment from 'moment';
  import 'moment/locale/it';
  import config from '../../../../config';
  export default {
    components: {
      FunctionalCalendar,
      EventoForm,
    },

    data: () => ({
      Util,
      calendar: {},
      markedDates: [],
      elencoFunzioni: Security.enFunzione,
      ruoliUtente: Security.ruolo,
      isMobile: false,
      TipologiaEvento: '',
      caso4: true,
      infogaraDialog: false,
      formModes: Util.enFormMode,
      formMode: Util.enFormMode.VISUALIZZAZIONE,
      filtroAnnoSportivo: null,
      filtraEventi: '',
      inoutdoor: ['Indoor', 'Outdoor'],
      mese: null,
      dataIniziale: null,
      eventiMese: [],
      eventoObj: new EventoEntity(),
      imageObj: new ImageEntity(),
      headers: [
        { text: 'Modalità', sortable: true, value: 'isOpen', width: '80px', align: 'center' },
        { text: 'Data', sortable: true, value: 'DataEvento' },
        { text: 'Data Apertura', sortable: true, value: 'DataApertura' },
        { text: 'Data Chiusura', sortable: true, value: 'DataChiusura' },
        { text: 'Regione', sortable: true, value: 'SezioneDescrizione' },
        { text: 'Tipo', sortable: true, value: 'TipoEventoDescrizione' },
        { text: 'Sodalizio', sortable: true, value: 'AssociazioneDenominazione' },
        { text: 'Luogo', sortable: true, value: 'CittaIndirizzo' },
        { text: 'Titolo', sortable: true, value: 'TitoloEvento' },
        { text: 'Azioni', sortable: false, value: '', width: '180px', align: 'center' },
      ],
      pagination: {
        rowsPerPage: 10,
      },
    }),

    computed: {
      ...mapGetters('eventiModule', ['getEventiView', 'getEventoView', 'getEvento', 'getImage', 'getFiltroEventi']),
      ...mapGetters('associazioniModule', ['getAssociazione']),
      ...mapGetters('sharedModule', ['getSezioni']),
      ...mapGetters('sharedModule', ['getTipiEvento', 'getAnniSportivi', 'getTag']),
      ...mapGetters(['userData', 'dataCalendario']),

      associazione() {
        return this.getAssociazione;
      },

      objFormazione() {
        let obj = this.tipiEventoAll.filter((t) => t.Codice === 'FOR');
        let rv = {};
        for (let i = 0; i < obj.length; ++i) {
          rv[i] = obj[i];
        }
        return rv;
      },

      objDidattico() {
        let obj = this.tipiEventoAll.filter((t) => t.Codice === 'DIDA');
        let rv = {};
        for (let i = 0; i < obj.length; ++i) {
          rv[i] = obj[i];
        }
        return rv;
      },

      filtroEventi() {
        return this.getFiltroEventi;
      },

      eventi() {
        return this.getEventiView;
      },
      evento() {
        return this.getEvento;
      },
      image() {
        return this.getImage;
      },
      ruoloUtenteLoggato() {
        return this.userData.Role;
      },
      calculatedRow() {
        return this.$vuetify.breakpoint.name;
      },
      sezioni() {
        return this.getSezioni;
      },
      tipiEventoAll() {
        return this.getTipiEvento;
      },
      tipiEvento() {
        const vm = this;
        if (vm.filtroEventi.isGara === true) {
          return vm.getTipiEvento.filter((t) => t.Codice != 'DIDA' && t.Codice != 'FOR');
        } else {
          return vm.getTipiEvento.filter((t) => t.Codice === 'DIDA' || t.Codice === 'FOR');
        }
      },
      tag() {
        return this.getTag;
      },
      insertMode() {
        return this.propFormMode === this.formModes.INSERIMENTO;
      },
      modifyMode() {
        return this.propFormMode === this.formModes.MODIFICA;
      },
      viewMode() {
        return this.propFormMode === this.formModes.VISUALIZZAZIONE;
      },
      anniSportivi() {
        return this.getAnniSportivi;
      },
      isAdmin() {
        if (this.userData.Role) {
          return (
            ((this.propFormMode === this.formModes.MODIFICA || this.propFormMode === this.formModes.INSERIMENTO) && this.userData.Role === this.ruoli.UTENTE_AMMINISTRATIVO) ||
            this.userData.Role === this.ruoli.ADMIN
          );
        } else {
          return false;
        }
      },
      isAssociato() {
        let retVal = false;
        if (this.userData.Role == this.ruoliUtente.ASSOCIATO) {
          retVal = true;
        } else {
          retVal = false;
        }
        return retVal;
      },
      isEditModeAdmin() {
        let retVal = false;
        if (this.userData.Role) {
          if (this.propFormMode === this.formModes.MODIFICA || this.propFormMode === this.formModes.INSERIMENTO) {
            if (this.userData.Role === this.ruoli.UTENTE_AMMINISTRATIVO || this.userData.Role === this.ruoli.ADMIN) {
              retVal = true;
            }
          }
        }
        return retVal;
      },
      isEditMode() {
        let retVal = false;
        if (this.userData.Role) {
          if (this.propFormMode === this.formModes.MODIFICA || this.propFormMode === this.formModes.INSERIMENTO) {
            if (this.userData.Role === this.ruoli.UTENTE_AMMINISTRATIVO || this.userData.Role === this.ruoli.ADMIN) {
              retVal = true;
            }
            /*
          if (this.userData.Role === this.ruoli.RESPONSABILE_ASSOCIAZIONE && this.checkFunzione(this.elencoFunzioni.INSERIMENTO_EVENTO_ASSOCIAZIONE)) {
            retVal = true;
          }
          */
          }
        }
        return retVal;
      },
    },
    watch: {
      evento() {
        this.eventoObj = new EventoEntity(this.getEvento);
      },
      image() {
        this.imageObj = new ImageEntity(this.getImage);
      },
      breakPoinSize() {
        switch (this.$vuetify.breakpoint.name) {
          case 'sm':
          case 'xs':
            this.isMobile = true;
            break;
          case 'md':
          case 'lg':
          case 'xl':
            this.isMobile = false;
            break;
        }
      },
      calculatedRow() {
        switch (this.$vuetify.breakpoint.name) {
          case 'sm':
          case 'xs':
            this.isMobile = true;
            break;
          case 'md':
            this.isMobile = false;
            break;
          case 'lg':
            this.isMobile = false;
            break;
          case 'xl':
            this.isMobile = false;
            break;
        }
      },
    },

    created() {
      const vm = this;
      if (this.checkFunzione(this.elencoFunzioni.INSERIMENTO_EVENTO_ASSOCIAZIONE)) {
        this.loadAssociazione(this.userData.AssociazioneId);
      }

      if (!this.filtroEventi) {
        const filtroDefault = new FiltroEvento();
        filtroDefault.AnnoSportivo = {
          id: 183,
          Codice: '20242025',
          Descrizione: '2024/2025',
          Tipo: 'AnnoSportivo',
          Tag: null,
        };
        this.saveFiltroEventi(filtroDefault);
      }
      this.refreshEvents(this);
      bus.$on('eventoDialog', function (value) {
        if (!value) {
          vm.refreshEvents(vm);
          vm.eventoObj = new EventoEntity();
          vm.imageObj = new ImageEntity();
        }
      });

      switch (this.$vuetify.breakpoint.name) {
        case 'sm':
        case 'xs':
          this.isMobile = true;
          break;
        case 'md':
        case 'lg':
        case 'xl':
          this.isMobile = false;
          break;
      }
    },

    methods: {
      ...mapActions('eventiModule', [
        'loadEventiView',
        'loadEventiViewAdmin',
        'loadEvento',
        'loadEventoAsync',
        'loadImage',
        'deleteEvento',
        'loadInvito',
        'exportCalendarioXLS',
        'saveFiltroEventi',
        'loadPiazzola',
      ]),
      ...mapActions('associazioniModule', ['loadAssociazione']),
      ...mapActions('sharedModule', ['loadTipologie']),
      ...mapActions(['changeDataCalendario']),

      newDialog(i) {
        this.formMode = this.formModes.INSERIMENTO;
        this.eventoObj = new EventoEntity();
        this.imageObj = new ImageEntity();
        this.eventoObj.Associazione = new AssociazioneEntity(this.associazione);
        if (i === 0) {
          this.eventoObj.TipologiaEvento = 'Gara';
        } else if (i === 1) {
          this.eventoObj.Associazione.id = 2566; // da caricare come getter
          this.eventoObj.TipologiaEvento = 'Formazione';
          this.eventoObj.EmailRiferimento = 'csaincremona@arciericonfederati.it';
        } else if (i === 2) {
          this.eventoObj.TipologiaEvento = 'Didattico';
          this.eventoObj.isAttivo = true;
        }
        bus.$emit('eventoDialog', true);
      },

      downloadPiazzola(itemId) {
        this.loadPiazzola(itemId);
      },

      refreshEventi() {
        this.saveFiltroEventi(this.filtroEventi);

        if (this.userData.Role == this.ruoliUtente.UTENTE_AMMINISTRATIVO) {
          this.loadEventiViewAdmin(this.filtroEventi.AnnoSportivo.id);
        } else {
          this.loadEventiView(this.filtroEventi.AnnoSportivo.id);
        }
      },

      downloadFromWebview(url) {
        window.flutter_inappwebview.callHandler(
          'MobileDownload',
          JSON.stringify({
            urlToDownload: url,
          }),
        );
      },
      downloadInvito(idInvito) {
        if (this.userData.tipoAccesso && this.userData.tipoAccesso == 'WEB') {
          this.loadInvito(idInvito);
        } else if (this.userData.tipoAccesso && this.userData.tipoAccesso == 'APP') {
          this.downloadFromWebview('/eventi/' + idInvito + '/invito');
        }
      },
      exportCalendarioCorrente() {
        const vm = this;
        vm.exportCalendarioXLS(this.filtroEventi.AnnoSportivo.id);
      },

      refreshEvents(cmp) {
        const vm = cmp;
        if (!this.mese) {
          this.mese = new Date();
        }
        this.loadTipologie().then(() => {
          if (this.userData.Role == vm.ruoliUtente.UTENTE_AMMINISTRATIVO) {
            vm.loadEventiViewAdmin(this.filtroEventi.AnnoSportivo.id).then(() => {
              vm.mese = new Date(vm.dataCalendario);
              vm.eventi.forEach((evt) => {
                vm.markedDates.push(new Date(evt.DataEvento).toLocaleString('it-IT', { month: 'numeric', day: 'numeric', year: 'numeric' }));
              });
              if (vm.$refs.Calendar !== undefined) {
                vm.$refs.Calendar.ChooseDate(new Date(vm.dataCalendario).toLocaleString('it-IT', { month: 'numeric', day: 'numeric', year: 'numeric' }));
              }

              this.eventiMese = this.filterEventi(this.mese, this.filtroEventi);
            });
          } else {
            vm.loadEventiView(this.filtroEventi.AnnoSportivo.id).then(() => {
              vm.mese = new Date(vm.dataCalendario);
              vm.eventi.forEach((evt) => {
                vm.markedDates.push(new Date(evt.DataEvento).toLocaleString('it-IT', { month: 'numeric', day: 'numeric', year: 'numeric' }));
              });
              if (vm.$refs.Calendar !== undefined) {
                vm.$refs.Calendar.ChooseDate(new Date(vm.dataCalendario).toLocaleString('it-IT', { month: 'numeric', day: 'numeric', year: 'numeric' }));
              }
              this.eventiMese = this.filterEventi(this.mese, this.filtroEventi);
            });
          }
        });
      },

      dettaglioDialog(evento, t) {
        this.$router.push({ name: 'eventi/showevento', params: { idEvento: evento.id, operazione: 'd' } });
      },
      prenotazioneDialog(evento, t) {
        this.$router.push({ name: 'eventi/showevento', params: { idEvento: evento.id, operazione: 'p' } });
      },

      // eslint-disable-next-line max-params
      filterEventi(dataCalendario, filtro) {
        let eventiFiltrati = [];
        this.mese = new Date(dataCalendario);

        if (!filtro.isAnnuale) {
          eventiFiltrati = this.eventi.filter((e) => {
            const data = new Date(e.DataEvento);
            return data.getMonth() == this.mese.getMonth() && data.getFullYear() == this.mese.getFullYear();
          });
        } else if (!filtro.AnnoSportivo) {
          eventiFiltrati = this.eventi.filter((e) => {
            const data = new Date(e.DataEvento);
            return data.getFullYear() == this.mese.getFullYear();
          });
        } else {
          eventiFiltrati = this.eventi;
        }

        if (filtro.isGara) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            return e.TipologiaEvento == 'Gara';
          });
        } else {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            if (this.userData.Role === 'UTENTE_AMMINISTRATIVO') {
              return e.TipologiaEvento != 'Gara';
            } else {
              return e.TipoEventoCodice === 'FOR' || (e.TipoEventoCodice === 'DIDA' && e.AssociazioneId == this.userData.AssociazioneId);
            }
          });
        }

        if (this.userData.Role == this.ruoliUtente.RESPONSABILE_ASSOCIAZIONE) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            return e.isAttivo == true || e.AssociazioneId == this.userData.AssociazioneId;
          });
        } else if (this.userData.Role != this.ruoliUtente.UTENTE_AMMINISTRATIVO) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            return e.isAttivo == true;
          });
        }

        if (filtro.Sezione) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            return e.SezioneId == filtro.Sezione;
          });
        }
        if (filtro.TipoEvento) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            return e.TipoEventoCodice == filtro.TipoEvento.Codice;
          });
        }

        if (this.userData.Role == this.ruoliUtente.ASSOCIATO) {
          if (filtro.isNotIscritto == false) {
            eventiFiltrati = eventiFiltrati.filter((e) => {
              return e.IsIscritto == true;
            });
          }
        }

        if (filtro.AnnoSportivo) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            return e.AnnoSportivoId == filtro.AnnoSportivo.id;
          });
        }

        if (filtro.isIndoorOutdoor) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            return e.isIndoor == (filtro.isIndoorOutdoor === 'Indoor' ? true : false);
          });
        }

        if (this.filtroEventi.isAperti == true) {
          eventiFiltrati = eventiFiltrati.filter((e) => {
            const dataEvento = moment(e.DataEvento);
            return dataEvento.isSameOrAfter(moment(new Date()), 'day');
          });

        }
        Util.sortArrayByKey(eventiFiltrati, 'DataEvento');
        return eventiFiltrati;
      },

      canModifyEvento(idEvento, idAssociazione) {
        let retVal = false;
        if (idEvento) {
          if (Security.isAbilitata(this.elencoFunzioni.MODIFICA_EVENTO, this.userData.Role)) {
            retVal = true;
          } else if (this.userData.userid) {
            retVal = Security.isAbilitata(this.elencoFunzioni.MODIFICA_EVENTO_ASSOCIAZIONE, this.userData.Role) && this.userData.AssociazioneId == idAssociazione;
          }
        }
        return retVal;
      },
      viewBadge(dataEvento) {
        return moment(dataEvento).isSameOrAfter(moment(new Date()));
      },

      editItem(item) {
        const vm = this;
        this.loadEventoAsync(item.id).then(() => {
          this.loadImage(item.id).then(() => {
            vm.formMode = vm.checkFormMode(false);
            vm.eventoObj = new EventoEntity(vm.evento);
            vm.imageObj = new ImageEntity(vm.image);
            vm.dataIniziale = item.DataEvento;
            bus.$emit('eventoDialog', true);
          });
        });
      },
      viewItem(item) {
        const vm = this;
        this.loadEventoAsync(item.id).then(() => {
          this.loadImage(item.id).then(() => {
            vm.formMode = vm.formModes.VISUALIZZAZIONE;
            bus.$emit('eventoDialog', true);
          });
        });
      },
      isFiltroIscritto() {
        return this.userData.Role === this.ruoliUtente.ASSOCIATO;
      },
      manageIscritti(idEvento, idAnnoSportivo) {
        // eslint-disable-next-line object-curly-spacing
        this.$router.push({ name: 'eventi/calendario/partecipazioni', params: { idEvento: idEvento,  idAnnoSportivo: idAnnoSportivo} });
      },
      manageClassifica(idEvento) {
        // eslint-disable-next-line object-curly-spacing
        this.$router.push({ name: 'eventi/calendario/classifica', params: { idEvento: idEvento } });
      },
      disableClassifica(item) {
        let retVal = true;
        if (moment(item.DataEvento).isSameOrBefore(moment(new Date())) || this.canModifyEvento(item.id, item.AssociazioneId) || item.Classificati > 0) {
          retVal = false;
        }
        if (item.TipologiaEvento != 'Gara') {
          retVal = true;
        }

        return retVal;
      },

      colorClassifica(item) {
        let retVal = 'orange';
        if (item.Classificati > 0) {
          retVal = 'primary';
        }
        return retVal;
      },

      resetElm() {
        this.eventoObj = new EventoEntity();
        this.eventoObj.Associazione = new AssociazioneEntity(this.associazione);
        this.imageObj = new ImageEntity();
      },
      checkFunzione(func) {
        return Security.isAbilitata(func, this.userData.Role);
      },
      checkFormMode(insertMode) {
        if (
          insertMode &&
          (Security.isAbilitata(this.elencoFunzioni.INSERIMENTO_EVENTO, this.userData.Role) ||
            Security.isAbilitata(this.elencoFunzioni.INSERIMENTOEVENTO_ASSOCIAZIONE, this.userData.Role))
        ) {
          this.mode = this.formModes.INSERIMENTO;
          return this.formModes.INSERIMENTO;
        } else if (Security.isAbilitata(this.elencoFunzioni.MODIFICA_EVENTO, this.userData.Role)) {
          this.mode = this.formModes.MODIFICA;
          return this.formModes.MODIFICA;
        } else if (Security.isAbilitata(this.elencoFunzioni.MODIFICA_EVENTO_ASSOCIAZIONE, this.userData.Role)) {
          this.mode = this.formModes.MODIFICA;
          return this.formModes.MODIFICA;
        } else if (Security.isAbilitata(this.elencoFunzioni.VISUALIZZAZIONE_EVENTO, this.userData.Role)) {
          this.mode = this.formModes.VISUALIZZAZIONE;
          return this.formModes.VISUALIZZAZIONE;
        }
      },

      changedMonth(d) {
        this.changeDataCalendario(new Date(d));
        this.mese = new Date(this.dataCalendario);
        this.eventiMese = this.filterEventi(this.dataCalendario, this.filtroEventi);
      },
      filtraTipoEvt(t) {
        if (t) {
          this.filtroEventi.TipoEvento = t;
        } else {
          this.filtroEventi.TipoEvento = null;
        }
        this.eventiMese = this.filterEventi(this.dataCalendario, this.filtroEventi);
      },

      filtraSez(s) {
        this.filtroEventi.Sezione = s;
        this.eventiMese = this.filterEventi(this.dataCalendario, this.filtroEventi);
      },

      filtraAnnoSez(i) {
        this.filtroEventi.AnnoSportivo = i;
        this.refreshEvents(this);
        //this.eventiMese = this.filterEventi(this.dataCalendario, this.filtroEventi);
        /*if (this.userData.Role == this.ruoliUtente.UTENTE_AMMINISTRATIVO) {
          this.eventiMese =  this.loadEventiViewAdmin(this.filtroEventi.AnnoSportivo.id).then(this.filterEventi(this.dataCalendario, this.filtroEventi));
        } else {
          this.loadEventiView(this.filtroEventi.AnnoSportivo.id).then(this.filterEventi(this.dataCalendario, this.filtroEventi));
        }*/
      },

      filtraTipoTag(i) {
        this.filtroEventi.isIndoorOutdoor = i;
        this.eventiMese = this.filterEventi(this.dataCalendario, this.filtroEventi);
      },

      filtraIscritti() {
        this.eventiMese = this.filterEventi(this.dataCalendario, this.filtroEventi);
      },
      filtraAnnuale() {
        this.eventiMese = this.filterEventi(this.dataCalendario, this.filtroEventi);
      },
      filtraAperti() {
        this.eventiMese = this.filterEventi(this.dataCalendario, this.filtroEventi);
      },
      filtraGaraForDida(i) {
        this.filtroEventi.isGara = i;
        this.filtroEventi.TipoEvento = null;
        this.eventiMese = this.filterEventi(this.dataCalendario, this.filtroEventi);
      },
    },
  };
</script>

<style>
  .textR {
    text-align: right !important;
  }

  .colorDisabled {
    color: #0000008a;
  }

  .switchEventi .v-input--switch__thumb {
    color: var(--v-accent-base) !important;
  }
  .switchEventi .v-input--switch__track {
    color: rgba(0, 0, 0, 0.38) !important;
  }
  .switchEventi .v-label {
    font-size: 14px !important;
  }
</style>

<style css-scoped>
  .padlist {
    padding-left: 4em;
  }

  @media screen and (max-width: 768px) {
    .mobile table.v-table tr {
      height: auto;
      padding-bottom: 0em !important;
    }

    .padlist {
      padding-left: 0em !important;
    }

    .v-btn--floating.v-btn--small {
      height: 26px;
      width: 26px;
    }

    .mobile table.v-table tbody td:first-child,
    table.v-table tbody td:not(:first-child),
    table.v-table tbody th:first-child,
    table.v-table tbody th:not(:first-child),
    table.v-table thead td:first-child,
    table.v-table thead td:not(:first-child),
    table.v-table thead th:first-child,
    table.v-table thead th:not(:first-child) {
      padding: 0px 2px !important;
    }

    .mobile table.v-table tr {
      max-width: 100%;
      position: relative;
    }

    .mobile table.v-table tr:nth-child(odd) {
      border-left: 1px solid grey;
      border-top: 1px solid grey;
      border-right: 1px solid grey;
    }

    .mobile table.v-table tr:nth-child(even) {
      border-left: 1px solid grey;
      border-top: 1px solid grey;
      border-right: 1px solid grey;
      background-color: #eeeeff;
    }
  }
</style>
